import { useEffect, useState } from "react";
import { getItem, setItem, onChange } from "../lib/safeStorage";

const KEY = "zen_age_verified_v1";

function shouldShow() {
    return !getItem(KEY);
}

export default function AgeGate({ brand }) {
    const [open, setOpen] = useState(shouldShow);

    // Cross-tab sync: if the user verifies their age in another tab,
    // dismiss the gate here instantly.
    useEffect(() => {
        return onChange(KEY, (newVal) => {
            if (newVal) setOpen(false);
        });
    }, []);

    const accept = () => {
        setItem(KEY, "1");
        setOpen(false);
    };
    const deny = () => {
        window.location.href = "https://www.google.com";
    };

    if (!open) return null;

    return (
        <div
            data-testid="age-gate-modal"
            className="fixed inset-0 z-[200] flex items-center justify-center bg-zen-bg/95 backdrop-blur-2xl px-6"
            role="dialog"
            aria-modal="true"
            aria-label="Age verification"
        >
            <div className="relative w-full max-w-xl border border-zen-ink/10 bg-zen-surface px-8 py-12 sm:px-14 sm:py-16 text-center shadow-[0_20px_80px_rgba(31,36,24,0.18)]">
                {brand?.logo && (
                    <img
                        src={brand.logo}
                        alt="ZenZest Cannabis"
                        className="mx-auto mb-8 w-20 h-20 object-contain"
                    />
                )}
                <p className="text-[11px] tracking-[0.35em] uppercase text-zen-olive mb-6">
                    weeddispensarynearme.com
                </p>
                <h1 className="font-serif text-4xl sm:text-5xl font-light text-zen-ink leading-[1.05] mb-4">
                    Are you 21 or older?
                </h1>
                <p className="text-zen-ink-soft text-sm sm:text-base max-w-md mx-auto mb-10 leading-relaxed">
                    You must be 21 years or older to enter. By entering, you
                    confirm you&rsquo;re of legal age in your state to purchase
                    cannabis.
                </p>
                <div className="flex flex-col sm:flex-row gap-3 sm:gap-4 justify-center">
                    <button
                        data-testid="age-gate-accept"
                        onClick={accept}
                        className="px-8 py-4 bg-zen-olive hover:bg-zen-olive-dark transition-colors duration-300 text-zen-bg tracking-wide font-medium text-sm uppercase"
                    >
                        Yes, I&rsquo;m 21+
                    </button>
                    <button
                        data-testid="age-gate-deny"
                        onClick={deny}
                        className="px-8 py-4 border border-zen-ink/30 hover:border-zen-ink/80 hover:bg-zen-ink/5 transition-colors duration-300 text-zen-ink-soft hover:text-zen-ink tracking-wide font-medium text-sm uppercase"
                    >
                        No, exit
                    </button>
                </div>
                <p className="mt-10 text-[10px] tracking-[0.2em] uppercase text-zen-muted">
                    For use only by adults 21+ &bull; Keep out of reach of
                    children
                </p>
            </div>
        </div>
    );
}
